import { createSelector, createFeatureSelector } from '@ngrx/store';
import { applicationFeatureKey } from './applications.reducers';
import { AppState, ApplicationsState } from './applications.reducers';
import { orderBy } from 'lodash-es';

import {
  selectHightlightUsedTypes,
} from 'src/app/+state/index';
import { getUserDateRange } from '../user-settings';
import { HiveApplication } from 'src/app/applications/hive-application';
import { ApplicationSearchState } from 'src/app/applications/application-filter-form/application-filter-form.component';
import { isBefore, parseISO } from 'date-fns';

export const applicationsStateSelectors = (state: AppState) => state.applications;
export const selectApplicationsFeature = createFeatureSelector< ApplicationsState>(
  applicationFeatureKey
);

export const selectTypesForFilter = createSelector(selectHightlightUsedTypes, (types) => types);

export const getHiveApplications = createSelector(
  applicationsStateSelectors,
  (state) => state.applications
);

export const getItemUsesTableFilter = createSelector(
  applicationsStateSelectors,
  getUserDateRange,
  (state, dateRange) => ({
    ...state.itemUsesTableFilter,
    dateRange
  })
);

export const getFilteredHiveApplications = createSelector(
  getHiveApplications,
  getItemUsesTableFilter,
  (applications, tableFilter) => orderBy(filterApplications(applications, tableFilter), 'applicationDate', 'desc')
);
// TODO: improve this code to only have one filter
function filterApplications(hiveApplications: HiveApplication[], tableFilter: ApplicationSearchState) {
  const query = (tableFilter.query || '').toLowerCase().trim();
  if (query !== '') {
    const regex = new RegExp(query, 'i');
    hiveApplications = hiveApplications.filter((item) => regex.test([item.comment].join(' ')));
  }

  if (tableFilter.hive) {
    hiveApplications = hiveApplications.filter(item => item.hive?.id === tableFilter.hive.id);
  }

  if (tableFilter.itemType) {
    hiveApplications = hiveApplications.filter(item => item.itemType?.id === tableFilter.itemType.id);
  }

  hiveApplications = hiveApplications?.filter(hiveApplication => {
    if (!tableFilter.dateRange || !tableFilter.dateRange.start || !tableFilter.dateRange.end) {
      return true;
    }
    const hiveApplicationDate = parseISO('' + hiveApplication.create_date);
    return isBefore(hiveApplicationDate, tableFilter.dateRange.end) && isBefore(tableFilter.dateRange.start, hiveApplicationDate);
  });

  return hiveApplications;
}
